import i18n from "@/language/i18n";

const NOTIFICATION_MODULE_WINDOW_IDENTIFIER = Object.freeze({
  NOTIFICATION_MODULE_WINDOW_ID: 'notifications',
});

export { NOTIFICATION_MODULE_WINDOW_IDENTIFIER };

export default {
  NOTIFICATION_GROUP_WRAPPER: {
    type: 'group',
    id: 'notifications',
    label: i18n.t('ModuleRegistry.groups.messages.name'),
    children: [],
    icon: '$wNotification',
    sidebarIcon: '$wNavNotification'
  },
  CHILDREN: {
    NOTIFICATION_MODULE: {
      type: 'module',
      id: 'notifications',
      windowIdentifierType:
        NOTIFICATION_MODULE_WINDOW_IDENTIFIER.NOTIFICATION_MODULE_WINDOW_ID,
      label: i18n.t('ModuleRegistry.groups.messages.messages.label'),
      navigationImg: require('@/assets/navigation/items/icon_mitarbeiter.svg'),
      routerLink: '/notifications',
    },
  },
};
